var _g, _g2, _path, _path2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 304,
    viewBox: "0 0 576 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.083 154.03C264.85 154.88 244.814 159.233 228.665 168.552C222.166 172.304 215.905 177.114 211.168 183.053C206.411 189.023 203.218 196.144 203.218 204.012C203.218 213.537 207.851 221.829 214.164 228.38C220.466 234.931 228.572 239.927 236.739 243.597C253.168 250.977 272.313 254.169 290.1 254.169C307.887 254.169 327.021 250.977 343.45 243.597C351.628 239.927 359.734 234.921 366.036 228.37C372.338 221.819 376.971 213.537 376.971 204.012C376.971 199.026 375.686 194.268 373.437 189.853C368.721 180.607 360.159 173.527 351.525 168.541C345.938 165.318 340.144 162.809 334.049 160.747C317.91 155.305 299.988 153.242 283.083 154.03Z",
    fill: "url(#paint0_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.841 148.854L282.841 148.854C300.299 148.041 318.875 150.162 335.705 155.837L335.71 155.839C342.073 157.992 348.187 160.633 354.115 164.053L354.116 164.054C363.195 169.297 372.703 177.008 378.054 187.499L378.055 187.501C380.629 192.555 382.154 198.113 382.154 204.013C382.154 215.304 376.657 224.806 369.771 231.964C362.873 239.135 354.146 244.479 345.574 248.325C328.334 256.069 308.444 259.353 290.1 259.353C271.756 259.353 251.856 256.07 234.616 248.325L234.616 248.325C226.059 244.481 217.332 239.149 210.432 231.977C203.531 224.817 198.035 215.303 198.035 204.013C198.035 194.687 201.826 186.461 207.115 179.824L207.116 179.822C212.371 173.234 219.197 168.035 226.073 164.065L226.075 164.064C243.149 154.211 264.062 149.729 282.841 148.854ZM214.164 228.381C220.466 234.932 228.572 239.928 236.739 243.598C253.168 250.978 272.313 254.17 290.1 254.17C307.887 254.17 327.021 250.978 343.45 243.598C351.628 239.928 359.734 234.922 366.036 228.371C372.338 221.82 376.971 213.538 376.971 204.013C376.971 199.027 375.686 194.269 373.437 189.854C368.721 180.608 360.159 173.528 351.525 168.542C345.938 165.319 340.144 162.81 334.049 160.748C317.91 155.306 299.988 153.243 283.083 154.031C264.85 154.881 244.814 159.234 228.665 168.553C222.166 172.305 215.905 177.115 211.168 183.054C206.41 189.024 203.218 196.145 203.218 204.013C203.218 213.538 207.851 221.83 214.164 228.381Z",
    fill: "#A2ABC2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283.083 154.03C264.85 154.88 244.814 159.233 228.665 168.552C222.166 172.304 215.905 177.114 211.168 183.053C206.411 189.023 203.218 196.144 203.218 204.012C203.218 213.537 207.851 221.829 214.164 228.38C220.466 234.931 228.572 239.927 236.739 243.597C253.168 250.977 272.313 254.169 290.1 254.169C307.887 254.169 327.021 250.977 343.45 243.597C351.628 239.927 359.734 234.921 366.036 228.37C372.338 221.819 376.971 213.537 376.971 204.012C376.971 199.026 375.686 194.268 373.437 189.853C368.721 180.607 360.159 173.527 351.525 168.541C345.938 165.318 340.144 162.809 334.049 160.747C317.91 155.305 299.988 153.242 283.083 154.03Z",
    fill: "url(#paint1_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.841 148.854L282.841 148.854C300.299 148.041 318.875 150.162 335.705 155.837L335.71 155.839C342.073 157.992 348.187 160.633 354.115 164.053L354.116 164.054C363.195 169.297 372.703 177.008 378.054 187.499L378.055 187.501C380.629 192.555 382.154 198.113 382.154 204.013C382.154 215.304 376.657 224.806 369.771 231.964C362.873 239.135 354.146 244.479 345.574 248.325C328.334 256.069 308.444 259.353 290.1 259.353C271.756 259.353 251.856 256.07 234.616 248.325L234.616 248.325C226.059 244.481 217.332 239.149 210.432 231.977C203.531 224.817 198.035 215.303 198.035 204.013C198.035 194.687 201.826 186.461 207.115 179.824L207.116 179.822C212.371 173.234 219.197 168.035 226.073 164.065L226.075 164.064C243.149 154.211 264.062 149.729 282.841 148.854ZM214.164 228.381C220.466 234.932 228.572 239.928 236.739 243.598C253.168 250.978 272.313 254.17 290.1 254.17C307.887 254.17 327.021 250.978 343.45 243.598C351.628 239.928 359.734 234.922 366.036 228.371C372.338 221.82 376.971 213.538 376.971 204.013C376.971 199.027 375.686 194.269 373.437 189.854C368.721 180.608 360.159 173.528 351.525 168.542C345.938 165.319 340.144 162.81 334.049 160.748C317.91 155.306 299.988 153.243 283.083 154.031C264.85 154.881 244.814 159.234 228.665 168.553C222.166 172.305 215.905 177.115 211.168 183.054C206.41 189.024 203.218 196.145 203.218 204.013C203.218 213.538 207.851 221.83 214.164 228.381Z",
    fill: "#A2ABC2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.431 28.5067C555.928 28.7969 556.136 29.4084 555.908 29.9371C542.433 60.8775 528.968 91.8179 515.504 122.769C515.421 122.955 515.338 123.142 515.255 123.328C515.027 123.857 515.234 124.469 515.732 124.759C515.825 124.811 515.918 124.862 516.011 124.925C519.836 127.122 523.661 129.34 527.496 131.548C527.994 131.838 528.201 132.45 527.963 132.978C524.677 140.535 521.391 148.101 518.095 155.658C517.888 156.145 517.359 156.414 516.841 156.321C513.358 155.627 509.886 154.943 506.403 154.248C506.278 154.227 506.164 154.186 506.061 154.124C504.941 153.471 503.822 152.828 502.692 152.185C498.536 161.753 494.369 171.32 490.202 180.897C489.984 181.384 489.466 181.654 488.948 181.55C485.465 180.866 481.982 180.182 478.51 179.488C478.385 179.467 478.271 179.425 478.168 179.363C470.622 174.999 463.076 170.646 455.53 166.293C455.032 166.002 454.825 165.391 455.053 164.862C459.5 154.652 463.947 144.443 468.383 134.233C468.466 134.046 468.549 133.86 468.632 133.673C468.86 133.144 468.652 132.533 468.155 132.243C468.062 132.191 467.968 132.139 467.875 132.077C452.234 123.049 436.593 114.02 420.951 104.992C420.485 104.712 420.267 104.132 420.464 103.624C422.724 97.4462 424.994 91.2789 427.264 85.1115C427.336 84.9042 427.461 84.7488 427.637 84.614C458.577 60.8153 489.528 37.0269 520.469 13.2386C520.759 13.0209 521.018 12.9587 521.381 13.0209C524.988 13.7361 528.595 14.4513 532.202 15.1665C532.326 15.1873 532.44 15.2287 532.554 15.3013C540.173 19.6962 547.802 24.1014 555.431 28.5067ZM481.194 104.816C486.025 93.7147 490.855 82.6135 495.685 71.5123C486.097 78.9131 476.509 86.3139 466.921 93.7251C466.434 94.0983 465.957 94.4714 465.47 94.8446C465.159 95.083 465.19 95.5805 465.532 95.7774C465.999 96.0366 466.455 96.3061 466.911 96.5652C471.669 99.3224 476.426 102.069 481.194 104.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.07 133.226C337.666 131.298 339.273 129.381 340.88 127.453C341.025 127.266 341.18 127.215 341.408 127.256C343.523 127.619 345.627 127.982 347.741 128.344C348.032 128.396 348.229 128.655 348.208 128.946C345.565 167.618 342.911 206.291 340.258 244.975C336.246 246.612 332.162 247.991 327.985 249.162C328.089 247.587 328.203 246.011 328.306 244.446C328.348 243.866 327.944 243.347 327.374 243.254C310.768 240.383 294.163 237.512 277.558 234.64C277.123 240.943 276.698 247.245 276.262 253.536C272.272 253.174 268.322 252.635 264.384 251.93C267.338 208.883 270.282 165.825 273.236 122.778C273.246 122.643 273.277 122.54 273.36 122.457C274.977 120.519 276.594 118.58 278.211 116.642C278.356 116.466 278.501 116.404 278.74 116.445C280.844 116.808 282.958 117.181 285.073 117.544C285.353 117.596 285.56 117.844 285.539 118.135C284.378 135.092 283.217 152.039 282.056 168.997C282.015 169.577 282.419 170.085 282.989 170.189C299.595 173.06 316.2 175.931 332.805 178.792C333.842 163.721 334.868 148.65 335.904 133.579C335.915 133.444 335.956 133.34 336.039 133.257C336.049 133.247 336.06 133.237 336.07 133.226ZM331.789 193.687C331.831 193.107 331.426 192.599 330.846 192.495C314.241 189.624 297.636 186.753 281.03 183.882C280.211 195.843 279.393 207.794 278.574 219.746C278.532 220.326 278.937 220.844 279.517 220.938C296.122 223.809 312.727 226.68 329.333 229.551C330.151 217.6 330.97 205.638 331.789 193.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.82 215.59C41.6645 223.55 41.509 231.5 41.3535 239.461C41.3431 239.855 41.7267 240.135 42.0998 240C42.6906 239.793 43.2815 239.585 43.8723 239.378C49.4903 237.377 55.1186 235.387 60.747 233.387C54.4345 227.458 48.1324 221.529 41.82 215.59ZM134.372 249.888C134.372 255.092 134.372 260.295 134.372 265.498C134.372 265.986 134.071 266.411 133.615 266.566C124.742 269.717 115.87 272.868 106.997 276.009C106.593 276.154 106.147 276.061 105.836 275.77C99.9278 270.215 94.0196 264.659 88.101 259.103C87.987 258.989 87.8626 258.875 87.7486 258.761C87.4376 258.471 86.9919 258.378 86.598 258.523C86.3493 258.606 86.0901 258.699 85.8414 258.782C66.8625 265.519 47.894 272.246 28.9152 278.973C28.542 279.108 28.1274 279.036 27.8268 278.797C24.0227 275.729 20.2187 272.671 16.425 269.614C16.1244 269.365 16 269.116 16 268.732C16 263.571 16 258.419 16 253.267C16.5805 228.225 17.1713 203.182 17.7517 178.14C17.7621 177.673 18.0627 177.259 18.498 177.103C27.6506 173.859 36.7928 170.615 45.9453 167.37C46.3392 167.225 46.7849 167.318 47.0959 167.609C64.9968 184.431 82.8873 201.265 100.788 218.077C100.902 218.191 101.027 218.295 101.141 218.409C101.452 218.699 101.897 218.792 102.291 218.658C102.54 218.564 102.789 218.481 103.048 218.388C107.785 216.709 112.532 215.019 117.279 213.34C117.684 213.195 118.119 213.288 118.43 213.579C122.752 217.642 127.064 221.695 131.386 225.758C131.511 225.872 131.563 225.996 131.563 226.162C131.563 231.366 131.563 236.569 131.563 241.772C131.563 242.259 131.262 242.684 130.806 242.84C129.915 243.161 129.034 243.472 128.142 243.783C130.153 245.69 132.174 247.587 134.195 249.484C134.32 249.598 134.372 249.722 134.372 249.888Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M329.333 229.552C329.208 231.324 329.094 233.097 328.97 234.869C328.918 235.543 328.306 236.02 327.643 235.906C309.981 232.858 292.328 229.801 274.666 226.753C274.376 226.701 274.127 226.536 273.961 226.318L278.76 220.451C278.926 220.7 279.196 220.887 279.517 220.938C296.122 223.81 312.727 226.681 329.333 229.552Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M332.805 178.793C332.681 180.566 332.566 182.349 332.442 184.121C332.401 184.785 331.779 185.272 331.126 185.158C313.463 182.1 295.801 179.053 278.149 175.995C277.838 175.943 277.568 175.756 277.413 175.508L282.243 169.703C282.409 169.952 282.678 170.128 282.989 170.19C299.594 173.061 316.2 175.933 332.805 178.793Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M348.094 128.551L343.243 134.366C343.16 134.263 343.036 134.19 342.901 134.159C340.786 133.796 338.672 133.433 336.568 133.06C336.391 133.029 336.215 133.091 336.091 133.205C337.677 131.288 339.273 129.37 340.88 127.453C341.025 127.266 341.18 127.214 341.408 127.256C343.523 127.618 345.627 127.981 347.741 128.344C347.887 128.375 348.001 128.448 348.094 128.551Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M285.415 117.751L280.574 123.556C280.491 123.452 280.367 123.379 280.232 123.348C278.118 122.985 276.003 122.623 273.889 122.26C273.712 122.229 273.536 122.291 273.412 122.405C275.008 120.487 276.604 118.559 278.211 116.642C278.356 116.466 278.501 116.404 278.74 116.445C280.844 116.808 282.958 117.181 285.073 117.544C285.207 117.575 285.332 117.647 285.415 117.751Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.563 226.162C131.563 231.365 131.563 236.569 131.563 241.772C131.563 242.259 131.262 242.684 130.806 242.84C129.915 243.161 129.034 243.472 128.142 243.783C124.245 240.124 120.347 236.465 116.45 232.796C116.139 232.506 116.243 231.998 116.647 231.853C121.488 230.132 126.339 228.422 131.179 226.701C131.428 226.608 131.563 226.39 131.563 226.162Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2421 229.314C72.0659 229.376 71.8897 229.438 71.7135 229.501C68.0649 230.796 64.4059 232.092 60.7573 233.388C60.747 233.388 60.747 233.388 60.747 233.388L41.8199 215.59C41.9029 211.455 41.9754 207.309 42.0583 203.162C42.0687 202.862 42.0687 202.561 42.0791 202.261C42.0894 201.887 42.0894 201.514 42.0998 201.141C42.1102 200.654 42.6906 200.405 43.0534 200.747C43.7375 201.39 44.4216 202.033 45.1057 202.675C54.2168 211.237 63.3279 219.799 72.439 228.371C72.75 228.661 72.6463 229.169 72.2421 229.314Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.314 263.011C28.314 268.349 28.314 273.677 28.314 279.015C28.1378 278.984 27.9719 278.911 27.8268 278.797C24.0227 275.729 20.2187 272.671 16.425 269.614C16.1244 269.365 16 269.116 16 268.733C16 263.571 16 258.419 16 253.268C19.9388 256.439 23.8776 259.611 27.8268 262.783C27.9616 262.897 28.1378 262.98 28.314 263.011Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2096 242.477V258.481C87.0023 258.439 86.795 258.45 86.598 258.522C86.3493 258.605 86.0901 258.698 85.8414 258.781C66.8625 265.519 47.894 272.246 28.9152 278.973C28.7182 279.046 28.5109 279.056 28.314 279.014C28.314 273.676 28.314 268.349 28.314 263.01V263C28.5109 263.052 28.7182 263.041 28.9152 262.969C47.894 256.242 66.8625 249.504 85.8414 242.777C86.0901 242.684 86.3493 242.601 86.598 242.508C86.795 242.435 87.0023 242.425 87.2096 242.477Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.344 260.036C106.344 265.374 106.344 270.702 106.344 276.04C106.157 275.999 105.981 275.906 105.836 275.771C99.9278 270.215 94.0196 264.659 88.101 259.103C87.987 258.989 87.8626 258.875 87.7486 258.761C87.5931 258.616 87.4065 258.523 87.2096 258.482V242.478C87.4065 242.519 87.5931 242.612 87.7486 242.757C87.8626 242.861 87.987 242.975 88.101 243.089C94.0196 248.645 99.9278 254.201 105.836 259.756C105.981 259.902 106.157 259.985 106.344 260.026V260.036Z",
    fill: "url(#paint10_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.372 249.889C134.372 255.092 134.372 260.295 134.372 265.499C134.372 265.986 134.071 266.411 133.615 266.566C124.742 269.717 115.87 272.869 106.997 276.009C106.779 276.082 106.562 276.092 106.344 276.04C106.344 270.702 106.344 265.374 106.344 260.036V260.026C106.562 260.088 106.779 260.078 106.997 260.005C115.994 256.813 124.991 253.62 133.999 250.428C134.237 250.334 134.372 250.117 134.372 249.889Z",
    fill: "url(#paint11_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M72.439 228.37C63.3279 219.798 54.2169 211.236 45.1058 202.674C44.4216 202.032 43.7375 201.389 43.0534 200.746C42.6906 200.404 42.1102 200.653 42.0998 201.14C42.0895 201.513 42.0895 201.887 42.0791 202.26C42.0687 202.56 42.0687 202.861 42.0584 203.162C41.9754 207.308 41.9029 211.454 41.82 215.59C41.6645 223.55 41.509 231.511 41.3535 239.461C41.3431 239.855 41.7267 240.135 42.0998 240C42.6906 239.793 43.2815 239.585 43.8723 239.378C49.4903 237.377 55.1186 235.387 60.747 233.387C60.747 233.387 60.747 233.387 60.7574 233.387C64.4059 232.091 68.0649 230.795 71.7135 229.5C71.8897 229.438 72.0659 229.375 72.2421 229.313C72.6463 229.168 72.75 228.66 72.439 228.37ZM87.2096 242.477C87.0023 242.425 86.795 242.436 86.598 242.508C86.3493 242.602 86.0901 242.684 85.8414 242.778C66.8625 249.505 47.894 256.242 28.9152 262.969C28.7182 263.042 28.5109 263.052 28.314 263C28.1378 262.98 27.9616 262.897 27.8268 262.783C23.8776 259.611 19.9388 256.439 16 253.267C16.5805 228.225 17.1713 203.182 17.7517 178.14C17.7621 177.673 18.0627 177.259 18.498 177.103C27.6506 173.859 36.7928 170.615 45.9453 167.37C46.3392 167.225 46.7849 167.318 47.0959 167.609C64.9968 184.431 82.8873 201.265 100.788 218.077C100.902 218.191 101.027 218.295 101.141 218.409C101.452 218.699 101.897 218.792 102.291 218.658C102.54 218.564 102.789 218.481 103.048 218.388C107.785 216.709 112.532 215.019 117.279 213.34C117.684 213.195 118.119 213.288 118.43 213.579C122.752 217.642 127.064 221.695 131.386 225.758C131.5 225.872 131.563 226.017 131.563 226.162C131.563 226.39 131.428 226.608 131.179 226.701C126.339 228.422 121.488 230.132 116.647 231.853C116.243 231.998 116.139 232.506 116.45 232.796C120.347 236.465 124.245 240.124 128.142 243.783C130.153 245.69 132.174 247.587 134.195 249.484C134.32 249.598 134.372 249.743 134.372 249.888C134.372 250.116 134.237 250.334 133.999 250.427C124.991 253.62 115.994 256.812 106.997 260.005C106.779 260.077 106.562 260.088 106.344 260.026C106.157 259.984 105.981 259.901 105.836 259.756C99.9278 254.2 94.0196 248.644 88.101 243.089C87.987 242.975 87.8626 242.861 87.7486 242.757C87.5931 242.612 87.4065 242.519 87.2096 242.477Z",
    fill: "url(#paint12_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M277.413 175.507C277.568 175.756 277.838 175.943 278.149 175.995C295.801 179.052 313.463 182.1 331.126 185.158C331.779 185.272 332.401 184.784 332.442 184.121C332.567 182.349 332.681 180.566 332.805 178.793C333.842 163.722 334.878 148.661 335.904 133.58C335.915 133.455 335.966 133.341 336.039 133.258C336.049 133.238 336.07 133.217 336.091 133.207C336.215 133.093 336.391 133.03 336.568 133.062C338.672 133.435 340.786 133.797 342.901 134.16C343.036 134.191 343.16 134.264 343.243 134.368C343.326 134.471 343.378 134.616 343.367 134.761C340.807 172.077 338.257 209.392 335.697 246.717C333.157 247.619 330.587 248.438 327.985 249.163C328.089 247.588 328.203 246.012 328.306 244.447C328.348 243.867 327.944 243.348 327.374 243.255C310.768 240.384 294.163 237.513 277.558 234.641C276.501 234.455 275.454 234.279 274.397 234.092C273.733 233.978 273.122 234.465 273.08 235.129C272.666 241.109 272.261 247.09 271.847 253.061C269.349 252.75 266.861 252.376 264.384 251.931C267.338 208.884 270.282 165.826 273.236 122.779C273.246 122.655 273.287 122.541 273.36 122.458C273.381 122.437 273.391 122.416 273.412 122.406C273.536 122.292 273.712 122.23 273.889 122.261C276.003 122.624 278.118 122.986 280.232 123.349C280.367 123.38 280.491 123.453 280.574 123.557C280.657 123.66 280.709 123.805 280.699 123.95C279.538 140.898 278.377 157.855 277.216 174.803C277.195 175.062 277.268 175.31 277.413 175.507ZM331.789 193.688C331.831 193.108 331.426 192.6 330.846 192.496C314.241 189.625 297.636 186.754 281.03 183.893V183.883C279.983 183.706 278.926 183.52 277.879 183.344C277.216 183.23 276.604 183.706 276.553 184.38C275.62 198.104 274.676 211.827 273.733 225.561C273.712 225.841 273.795 226.111 273.961 226.318C274.127 226.536 274.376 226.702 274.666 226.753C292.329 229.801 309.981 232.859 327.643 235.906C328.306 236.02 328.918 235.543 328.97 234.869C329.094 233.097 329.208 231.325 329.333 229.552C330.151 217.601 330.97 205.639 331.789 193.688Z",
    fill: "url(#paint13_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M481.184 104.815C486.014 93.714 490.845 82.6127 495.685 71.5115C497.375 67.6245 499.075 63.7272 500.764 59.8402C501.241 58.7622 501.707 57.6738 502.184 56.5855C502.423 56.0465 501.759 55.5489 501.303 55.9325C500.889 56.2745 500.484 56.6166 500.07 56.9586C499.707 57.2385 499.334 57.5287 498.961 57.8086C484.449 69.0238 469.927 80.2391 455.406 91.444C454.929 91.8171 454.442 92.1903 453.965 92.5634C453.809 92.6878 453.737 92.864 453.747 93.0299C453.758 93.2164 453.851 93.3926 454.027 93.4963C454.483 93.7658 454.939 94.0249 455.395 94.2944C463.107 98.7411 470.808 103.188 478.51 107.635C478.717 107.749 478.914 107.873 479.121 107.987C479.412 108.163 479.785 108.039 479.92 107.728C480.054 107.427 480.189 107.116 480.313 106.816C480.604 106.152 480.894 105.479 481.184 104.815ZM544.423 26.8578C544.516 27.1066 544.506 27.3968 544.392 27.6559C530.927 58.6067 517.463 89.5471 503.988 120.488C503.915 120.674 503.832 120.861 503.749 121.047C503.625 121.317 503.625 121.597 503.708 121.856C503.791 122.115 503.967 122.333 504.216 122.478C504.309 122.529 504.413 122.592 504.506 122.644C508.341 124.862 512.156 127.059 515.98 129.267C516.229 129.412 516.405 129.64 516.488 129.899C516.571 130.158 516.571 130.438 516.457 130.697C513.047 138.534 509.637 146.359 506.227 154.195C506.164 154.175 506.113 154.154 506.061 154.123C504.941 153.48 503.812 152.827 502.692 152.185C499.748 150.485 496.815 148.785 493.871 147.085C493.84 147.075 493.819 147.054 493.799 147.043C493.768 147.023 493.736 147.012 493.705 147.002C493.135 146.743 492.462 146.981 492.202 147.572C492.151 147.686 492.109 147.79 492.057 147.904C487.486 158.414 482.905 168.925 478.334 179.435V179.445C478.271 179.425 478.22 179.394 478.168 179.362C470.622 174.999 463.076 170.645 455.53 166.292C455.032 166.002 454.825 165.39 455.053 164.861C459.5 154.652 463.947 144.442 468.383 134.232C468.466 134.045 468.549 133.859 468.632 133.672C468.86 133.144 468.652 132.532 468.155 132.242L467.875 132.076C452.234 123.048 436.593 114.02 420.951 104.991C420.485 104.712 420.267 104.131 420.464 103.623C422.724 97.4455 424.994 91.2781 427.264 85.1108C427.336 84.9035 427.461 84.748 427.637 84.6132C458.577 60.8145 489.528 37.0262 520.469 13.2378C520.655 13.0927 520.831 13.0201 521.028 13.0098C528.657 17.415 536.286 21.8203 543.925 26.2255C544.174 26.3706 544.35 26.5987 544.423 26.8578Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M555.928 29.1284L544.433 26.8584H544.423C544.35 26.5992 544.174 26.3712 543.925 26.2261C536.286 21.8208 528.657 17.4156 521.028 13.0103C521.132 12.9896 521.256 13 521.381 13.0207C524.988 13.7359 528.595 14.4511 532.202 15.1663C532.327 15.187 532.441 15.2285 532.555 15.3011C540.173 19.6959 547.802 24.1012 555.431 28.5064C555.68 28.6516 555.856 28.8692 555.928 29.1284Z",
    fill: "url(#paint15_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M466.911 96.5658C471.669 99.323 476.416 102.07 481.184 104.817C480.894 105.48 480.604 106.154 480.314 106.817C480.189 107.118 480.054 107.429 479.92 107.729C479.785 108.04 479.412 108.165 479.122 107.988C478.914 107.874 478.717 107.75 478.51 107.636C470.809 103.189 463.107 98.7425 455.395 94.2958C454.939 94.0263 454.483 93.7672 454.027 93.4977C453.851 93.394 453.758 93.2178 453.747 93.0312L465.253 95.3116C465.263 95.4878 465.356 95.6744 465.533 95.7781C465.999 96.0372 466.455 96.3067 466.911 96.5658Z",
    fill: "url(#paint16_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M501.303 55.9334C501.759 55.5499 502.423 56.0475 502.184 56.5864C501.708 57.6748 501.241 58.7632 500.764 59.8412C499.075 63.7281 497.375 67.6255 495.685 71.5125C486.097 78.9133 476.509 86.3141 466.922 93.7253C466.434 94.0985 465.958 94.4716 465.47 94.8448C465.315 94.9588 465.253 95.135 465.253 95.3112L453.747 93.0308C453.737 92.865 453.809 92.6888 453.965 92.5644C454.442 92.1912 454.929 91.8181 455.406 91.4449C469.928 80.2401 484.449 69.0248 498.961 57.8096C499.334 57.5297 499.707 57.2395 500.07 56.9596C500.484 56.6175 500.889 56.2755 501.303 55.9334Z",
    fill: "url(#paint17_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M277.558 234.641C277.122 240.943 276.698 247.245 276.262 253.537C274.78 253.402 273.308 253.247 271.847 253.06C272.261 247.09 272.665 241.109 273.08 235.128C273.121 234.465 273.733 233.978 274.396 234.092C275.454 234.278 276.501 234.455 277.558 234.641Z",
    fill: "url(#paint18_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M555.928 29.1284C556.032 29.3772 556.022 29.6674 555.908 29.9369C542.433 60.8773 528.968 91.8177 515.504 122.768C515.421 122.955 515.338 123.142 515.255 123.328C515.141 123.587 515.141 123.878 515.224 124.126L503.708 121.856C503.625 121.597 503.625 121.317 503.749 121.048C503.832 120.861 503.915 120.675 503.988 120.488C517.463 89.5477 530.927 58.6073 544.392 27.6565C544.506 27.3974 544.516 27.1072 544.423 26.8584H544.433L555.928 29.1284Z",
    fill: "url(#paint19_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M528.004 132.17C528.087 132.43 528.087 132.709 527.963 132.979C524.677 140.535 521.391 148.102 518.095 155.658C517.888 156.145 517.359 156.415 516.841 156.322C513.358 155.627 509.886 154.943 506.403 154.248C506.341 154.238 506.279 154.217 506.227 154.197C509.637 146.36 513.047 138.535 516.457 130.699C516.571 130.439 516.571 130.16 516.488 129.9L528.004 132.17Z",
    fill: "url(#paint20_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M528.004 132.169L516.488 129.899C516.405 129.64 516.229 129.412 515.98 129.267C512.156 127.059 508.341 124.861 504.506 122.643C504.413 122.591 504.309 122.529 504.216 122.477C503.967 122.332 503.791 122.115 503.708 121.855L515.224 124.125C515.307 124.385 515.483 124.613 515.732 124.758C515.825 124.81 515.918 124.861 516.012 124.924C519.836 127.121 523.661 129.339 527.496 131.547C527.745 131.692 527.921 131.91 528.004 132.169Z",
    fill: "url(#paint21_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M493.705 147.002C493.737 147.013 493.768 147.023 493.799 147.044C493.819 147.054 493.84 147.075 493.871 147.085C496.815 148.785 499.748 150.485 502.692 152.185C498.536 161.752 494.369 171.319 490.202 180.897C489.984 181.384 489.466 181.654 488.948 181.55C485.465 180.866 481.982 180.182 478.51 179.487C478.448 179.477 478.386 179.466 478.334 179.446V179.435C482.905 168.925 487.486 158.415 492.057 147.904C492.109 147.79 492.151 147.686 492.203 147.572C492.462 146.982 493.135 146.743 493.705 147.002Z",
    fill: "url(#paint22_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M348.094 128.552C348.177 128.655 348.218 128.801 348.208 128.946C345.565 167.619 342.911 206.291 340.258 244.975C338.744 245.597 337.22 246.167 335.697 246.716C338.257 209.391 340.807 172.076 343.367 134.761C343.377 134.615 343.326 134.47 343.243 134.367L348.094 128.552Z",
    fill: "url(#paint23_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M285.415 117.751C285.498 117.855 285.549 117.989 285.539 118.134C284.378 135.092 283.217 152.039 282.056 168.997C282.036 169.256 282.108 169.495 282.243 169.702L277.413 175.506C277.268 175.309 277.195 175.061 277.216 174.802C278.377 157.854 279.538 140.897 280.699 123.949C280.709 123.804 280.657 123.659 280.574 123.556L285.415 117.751Z",
    fill: "url(#paint24_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M281.03 183.882C280.211 195.854 279.393 207.795 278.574 219.746C278.553 220.005 278.625 220.254 278.76 220.451L273.961 226.318C273.795 226.11 273.712 225.841 273.733 225.561C274.676 211.827 275.62 198.103 276.552 184.38C276.604 183.706 277.216 183.229 277.879 183.343C278.926 183.519 279.983 183.706 281.03 183.882Z",
    fill: "url(#paint25_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 195.218,
    y: 149.868,
    width: 193.753,
    height: 120.301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 190.035,
    y: 144.687,
    width: 204.119,
    height: 130.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 0,
    y: 0.998047,
    width: 576,
    height: 302.042,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 205.173,
    y1: 154.815,
    x2: 370.797,
    y2: 262.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DA7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253863"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 205.173,
    y1: 154.815,
    x2: 370.797,
    y2: 262.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DA7BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253863"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 273.962,
    y1: 228.189,
    x2: 329.334,
    y2: 228.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 277.414,
    y1: 177.441,
    x2: 332.806,
    y2: 177.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 336.092,
    y1: 130.807,
    x2: 348.095,
    y2: 130.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 273.413,
    y1: 119.997,
    x2: 285.416,
    y2: 119.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 116.27,
    y1: 234.975,
    x2: 131.564,
    y2: 234.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 41.8212,
    y1: 216.991,
    x2: 72.6218,
    y2: 216.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 16.0013,
    y1: 266.144,
    x2: 28.3152,
    y2: 266.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 28.3152,
    y1: 260.744,
    x2: 87.2108,
    y2: 260.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 87.2108,
    y1: 259.261,
    x2: 106.345,
    y2: 259.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 106.345,
    y1: 262.983,
    x2: 134.373,
    y2: 262.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 15.9785,
    y1: 215.182,
    x2: 134.393,
    y2: 215.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 264.385,
    y1: 187.659,
    x2: 343.37,
    y2: 187.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 420.369,
    y1: 96.2516,
    x2: 544.508,
    y2: 96.2516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 521.03,
    y1: 21.0661,
    x2: 555.93,
    y2: 21.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 453.749,
    y1: 100.553,
    x2: 481.185,
    y2: 100.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 453.748,
    y1: 75.557,
    x2: 502.236,
    y2: 75.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 271.848,
    y1: 243.809,
    x2: 277.559,
    y2: 243.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 503.651,
    y1: 75.4949,
    x2: 556.001,
    y2: 75.4949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 506.228,
    y1: 143.123,
    x2: 528.063,
    y2: 143.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 503.709,
    y1: 127.015,
    x2: 528.005,
    y2: 127.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 478.335,
    y1: 164.238,
    x2: 502.693,
    y2: 164.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 335.698,
    y1: 187.636,
    x2: 348.21,
    y2: 187.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 277.214,
    y1: 146.631,
    x2: 285.542,
    y2: 146.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 273.731,
    y1: 204.824,
    x2: 281.031,
    y2: 204.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.650cb95e232eaf5210b686f47ec2f277.svg";
export { ForwardRef as ReactComponent };